<template>
    <div :class="className + ' border overwiew-item'" v-if="className == 'reverse'">
        <v-row no-gutters class="flex-column-reverse flex-lg-row">
            <v-col cols="12" lg="6">
                <div class="w-100 h-100 pa-20 pa-md-30 py-lg-16 px-xl-50 d-flex flex-column justify-center icon-box text-lg-right">
                    <div class="d-flex d-lg-block justify-end">
                        <v-img :src="icon" :max-width="iconWidth" class="icon-box-icon mb-6 mb-lg-0"></v-img>
                    </div>
                    <p class="color-point font-size-12 font-size-lg-16 line-height-1 mb-2 mb-lg-14">
                        {{num}}
                    </p>
                    <h5 class="tit--sm font-weight-medium mb-10 mb-lg-18">
                        {{tit}}
                    </h5>
                    <p class="color-grey-2c font-size-14 font-size-lg-16">
                        <slot/>
                    </p>
                </div>
            </v-col>
            <v-col cols="12" lg="6">
                <v-img :src="src" class="w-100"></v-img>
            </v-col>
        </v-row>
    </div>
    <div class="border overwiew-item" v-else>
        <v-row no-gutters>
            <v-col cols="12" lg="6">
                <v-img :src="src" class="w-100"></v-img>
            </v-col>
            <v-col cols="12" lg="6">
                <div class="w-100 h-100 pa-20 pa-md-30 py-lg-16 px-xl-50 d-flex flex-column justify-center icon-box">
                    <div class="d-flex d-lg-block justify-end">
                        <v-img :src="icon" :max-width="iconWidth" class="icon-box-icon mb-6 mb-lg-0"></v-img>
                    </div>
                    <p class="color-point font-size-12 font-size-lg-16 line-height-1 mb-2 mb-lg-14">
                        {{num}}
                    </p>
                    <h5 class="tit--sm font-weight-medium mb-10 mb-lg-18">
                        {{tit}}
                    </h5>
                    <p class="color-grey-2c font-size-14 font-size-lg-16">
                        <slot/>
                    </p>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default{
    props : {
        className : {type :String, default : ""},
        src : {type :String, default : ""},
        icon : {type :String, default : ""},
        iconWidth : {type :String, default : ""},
        num : {type :String, default : ""},
        tit : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.icon-box{
    position: relative;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .icon-box-icon{
        position: absolute;
        top: 30px;
        right: 30px;
    }
    .reverse .icon-box-icon{
        left: 30px;
        right: unset;
    }
}
@media (min-width:1200px){
    .icon-box-icon{
        top: 50px;
        right: 50px;
    }
    .reverse .icon-box-icon{
        left: 50px;
    }
}

</style>